module.exports = __webpack_public_path__ + "img/times.b01fd191.svg";